'use strict';
var modal = require('../modal-static');
var pixelateImage = require('../../js/pixelate').loadCanvas;

function getBigPhotoWrapper(noModalOpen){
  return document.querySelector(((noModalOpen) ? '' : '#modal ') + '#big-photo')
}

function getImageList(noModalOpen) {
  var imgDOM = document.querySelector(((noModalOpen) ? '' : '#modal ') + '#bottom-panel')
  return imgDOM ? Array.from(imgDOM.children) : []
}

function getCurrentPhotoPosition(currentImageSrcURL, images) {
  var currentCount = 0
  Array.from(images).forEach(function (image, index) { 
    if (currentImageSrcURL.toLowerCase().toString().indexOf(image.firstElementChild.dataset.bigPhoto.toLowerCase()) > -1) {
      return  currentCount = index
    }
  })
  return currentCount
}

function prevNextPhoto (e) {
  var bigPhotoWrapper = getBigPhotoWrapper(false)
  var images =  getImageList(false);

  var nextImageIndex = getCurrentPhotoPosition(bigPhotoWrapper.firstElementChild.src, images)

  if (e.target.dataset.bigPhotoNav == 'left') {
    nextImageIndex = nextImageIndex -1 < 0 ? images.length-1 : --nextImageIndex
  } else {
    nextImageIndex = nextImageIndex >= images.length-1 ? 0 : ++nextImageIndex
  }
  showPhoto(bigPhotoWrapper, images[nextImageIndex].children[0].dataset.bigPhoto)
}

function nextPhoto(e) {
  var bigPhotoWrapper = getBigPhotoWrapper(false)
  if (bigPhotoWrapper) {
    var images =  getImageList(false);

    // Choose photo to move too
    if ((images.length > 1)) {
      // Get the next element index
      var nextImageIndex = getCurrentPhotoPosition(bigPhotoWrapper.firstElementChild.src, images)

      //if next image is the last child, back to beginning
      if (nextImageIndex == images.length-1) {
        nextImageIndex = 0
      } else {
        nextImageIndex++;
      }
      showPhoto(bigPhotoWrapper, images[nextImageIndex].children[0].dataset.bigPhoto)
    }
  }
}

function smallPhotoNav(photoURL, photoNumber) {
  var noModalOpen = !(document.documentElement.classList.contains('modal-open'))
  var bigPhotoWrapper = getBigPhotoWrapper(noModalOpen)
  if (bigPhotoWrapper) {
    // Clicking on a small photo
    showPhoto(bigPhotoWrapper, photoURL, noModalOpen, photoNumber)
  }
}

function prevNextButtons(e) {
  if (e.target.dataset && e.target.dataset.bigPhotoNav == 'left') { 
    prevNextPhoto (e)
  } else if(e.target.dataset && e.target.dataset.bigPhotoNav == 'right') {
    nextPhoto(e)
  }

  if (e.target.dataset.bigPhoto) {
    // Clicking on a small photo
    var photoURL;
    var photoNumber = 0;
    photoURL = e.target.dataset.bigPhoto;
    photoNumber = e.target.dataset.photoNumber;
    smallPhotoNav(photoURL,photoNumber)
  }
}

function showPhoto(bigPhotoWrapper, photoURL, noModalOpen, photoNumber) {
  var currentImage = bigPhotoWrapper.querySelector('img')

  if (photoURL == currentImage.src) {
    // The phot
    return
  }

  var overlay = bigPhotoWrapper.parentElement.parentElement.querySelector('.overlay')
  overlay.style.width = currentImage.clientWidth + 'px'
  overlay.style.height = currentImage.clientHeight + 'px'
  overlay.parentElement.classList.remove('hide')

  var bigPhoto = new Image();
  bigPhoto.src = photoURL;
  if (noModalOpen) {
    // Update the modal URL
    bigPhoto.dataset.cmModalUrl = currentImage.dataset.cmModalUrl ? currentImage.dataset.cmModalUrl.replace(/photo=\d/, 'photo=' + photoNumber) : ''
  } else {
    bigPhoto.dataset.noSwap = 'false';
  }

  (noModalOpen) ? bigPhoto.classList.add('flex-none', 'fit', 'pointer') : bigPhoto.classList.add('flex-none', 'fit');
  bigPhoto.addEventListener('load', function () {
    bigPhotoWrapper.innerHTML = '';
    overlay.parentElement.classList.add('hide');
    bigPhotoWrapper.appendChild(bigPhoto)
  })
}

function overlayCloseInit (){
  document.addEventListener('click', function (e) {
    if(e.target.dataset && e.target.dataset.overlayClose){
      if(!e.target.dataset.photoNumber && document.documentElement.classList.contains('modal-open')){
        modal.destroy()
      }
    }
  })
}

function pixelPhoto(){
  var photo = document.querySelector('[data-pixelate-image]')
  if(photo){
    pixelateImage(photo, photo.parentElement, photo.getAttribute('src'))
  }
}

function modalLoaded(ev){
  if (ev.modalLoadingURL && /^\/([a-z]{2})\/profile\/showphotodisplaywidget\?/i.test(ev.modalLoadingURL)) {
    var images = getImageList(false)
    images.forEach(function(itm) {
      var bigPhoto = new Image();
      bigPhoto.src = itm.children[0].dataset.bigPhoto;
    })
  }
}

document.addEventListener('click', prevNextButtons);
document.addEventListener('DOMContentLoaded', overlayCloseInit)
document.addEventListener('DOMContentLoaded', pixelPhoto)
document.addEventListener('cm-modal-loaded', modalLoaded)
